module.exports = __webpack_public_path__ + "img/chip_selected.6cc2a64c.png";